import React, { useEffect } from 'react';
import ApiValidationErrorDisplay from '~/components/ApiValidationErrorDisplay';
import { clearApiValidationErrors } from '~/stores/redux/common/apiValidationErrorSlice';
import { schema } from './exchange.yup';
import DisplayFormikState from '~/components/DisplayFormikState';
import SubmitResetButtons from '~/components/FormControl/SubmitResetButtons';
import classNames from 'classnames/bind';
const cx = classNames.bind();
import { FormText, FormSelect, TextArea, Selectize, FormNumber } from '~/components/FormControl';
import { Formik } from 'formik';
import { Card, Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';
import { FileUploadedWithResetCount } from '~/components/FileUploaded';
import { useNavigate } from 'react-router-dom';
import { fetchCardMetaDataApi } from '~/pages/CardSaga/cardMetaDataSlice';
import { ITEMS } from '~/config/constants';

ExchangeForm.defaultProps = {
    pictureAttributeNames: null,
};
ExchangeForm.propTypes = {
    initialValues: PropTypes.object.isRequired,
    setResetCount: PropTypes.func.isRequired,
    pictureAttributeNames: PropTypes.array,
    resetCount: PropTypes.number.isRequired,
    formSubmit: PropTypes.func.isRequired,
};

function ExchangeForm({ initialValues, setResetCount, pictureAttributeNames, resetCount, formSubmit }) {
    const { isLoading } = useSelector((state) => state.loading);
    const { apiValidationErrors } = useSelector((state) => state.apiValidationError);

    const { cardMetaData } = useSelector((state) => state.cardSaga.cardMetaData);
    const { actions, powers, upgrades, characterClasses } = cardMetaData;

    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (isEmpty(cardMetaData)) {
            dispatch(fetchCardMetaDataApi(navigate));
        }
    }, []);

    return (
        <>
            {/* MUST put `isEmpty(exchangeMetaData)` in condition, else Bootstrap `Select` will not display value to UI (even though it's already stored value in it)  */}
            {!isEmpty(initialValues) && !isEmpty(cardMetaData) ? (
                <Card>
                    <Card.Body>
                        <Formik
                            initialValues={initialValues}
                            validateOnChange={false}
                            validationSchema={initialValues.id === null ? schema : schema(true)}
                            onSubmit={formSubmit}
                        >
                            {(props) => {
                                // eslint-disable-next-line react/prop-types
                                const { handleSubmit, isSubmitting, resetForm, values } = props;

                                return (
                                    <>
                                        <SubmitResetButtons
                                            isSubmitting={isSubmitting}
                                            handleSubmit={handleSubmit}
                                            setResetCount={setResetCount}
                                            resetForm={resetForm}
                                        />
                                        <Form.Row className="d-flex justify-content-between">
                                            <FormSelect
                                                name="from_item"
                                                options={[{
                                                    "id": "cash",
                                                    "name": "Cash"
                                                }].concat(ITEMS)}
                                                sm={2}
                                                label="From item"
                                                className={'offset-sm-1'}
                                            />
                                            <FormNumber
                                                name={'from_item_id'}
                                                label="From item id"
                                                sm={3}
                                            />
                                            <FormNumber
                                                name={'from_item_quantity'}
                                                label="From item quantity"
                                                sm={3}
                                            />
                                        </Form.Row>

                                        <Form.Row className="d-flex justify-content-between">
                                            <FormSelect
                                                name="to_item"
                                                options={[{
                                                    "id": "cash",
                                                    "name": "Cash"
                                                }].concat(ITEMS)}
                                                sm={2}
                                                label="To item"
                                                className={'offset-sm-1'}
                                            />
                                            <FormNumber
                                                name={'to_item_id'}
                                                label="To item id"
                                                sm={3}
                                            />
                                            <FormNumber
                                                name={'to_item_quantity'}
                                                label="To item quantity"
                                                sm={3}
                                            />
                                        </Form.Row>
                                        <SubmitResetButtons
                                            isSubmitting={isSubmitting}
                                            handleSubmit={handleSubmit}
                                            setResetCount={setResetCount}
                                            resetForm={resetForm}
                                        />
                                        <ApiValidationErrorDisplay
                                            errors={apiValidationErrors}
                                            clearError={clearApiValidationErrors}
                                        />
                                        <DisplayFormikState props={props} />
                                    </>
                                );
                            }}
                        </Formik>
                    </Card.Body>
                </Card>
            ) : (
                <Card style={{ position: 'relative' }}>
                    <Card.Body className={cx('row', { whirl: isLoading })}></Card.Body>
                </Card>
            )}
        </>
    );
}

export default ExchangeForm;
